<script>
  import moment from 'moment'
  import DatePicker from 'vuejs-datepicker'
  import {en, de} from 'vuejs-datepicker/dist/locale'
  import {faCalendar} from '@fortawesome/free-solid-svg-icons'
  import clickoutMixin from 'bootstrap-vue/esm/mixins/click-out.js'
  import formFieldMixin from './form-field-mixin.js'

  export default {
    mixins: [
      clickoutMixin,
      formFieldMixin
    ],
    components: {
      DatePicker
    },
    data () {
      return {
        trans: {en, de},
        dateValue: null,
        listenForClickOut: true,
        iconCalendar: faCalendar
      }
    },
    watch: {
      value (newVal, oldVal) {
        if (oldVal !== newVal) {
          this.dateValue = newVal ? moment(String(newVal)).toDate() : null
        }
      },
      dateValue (newVal, oldVal) {
        if (oldVal !== newVal) {
          this.updateField(newVal ? moment(newVal).format(this.format) : null)
        }
      }
    },
    methods: {
      clickOutHandler () {
        this.$refs.programaticOpen.close()
      },
      openPicker () {
        this.$refs.programaticOpen.showCalendar()
      }
    },
    props: {
      format: {
        type: String,
        default: undefined
      },
      clearButton: {
        type: Boolean,
        default: true
      }
    }
  }
</script>
<template>
  <b-form-group
    :description="description"
    :label="label"
    :label-for="inputName"
    :invalid-feedback="violations"
    :labelClass="labelClasses"
  >
    <date-picker
      :id="inputName"
      :value="value"
      @input="dateValue = $event"
      :clear-button="clearButton && !isRequired"
      format="dd.MM.yyyy"
      :monday-first="true"
      :language="trans.de"
      :placeholder="placeholder"
      :input-class="!isInvalid ? 'is-valid' : 'is-invalid'"
      :disabled="isReadOnly"
      :bootstrap-styling="true"
      ref="programaticOpen"
    >
      <b-input-group-append slot="afterDateInput">
        <b-btn variant="info" @click="openPicker" :disabled="isReadOnly"><font-awesome-icon :icon="iconCalendar" /></b-btn>
      </b-input-group-append>
    </date-picker>
  </b-form-group>
</template>
